import {
  Step,
  StepId,
  StepType,
  TypedStep,
} from "@redotech/redo-return-ui/flows/step";

export function generateStepId(existingSteps: Map<StepId, Step>): StepId {
  let maxId = -1;

  for (const stepId of existingSteps.keys()) {
    if (stepId === "start") continue;

    const numericId = parseInt(stepId, 10);
    if (!isNaN(numericId) && numericId > maxId) {
      maxId = numericId;
    }
  }

  return String(maxId + 1);
}

export function createStepFromType(
  stepType: StepType<any, any>,
  existingSteps: Map<StepId, Step>,
): Step {
  const defaultState = stepType.defaultInitialStateFn
    ? stepType.defaultInitialStateFn(existingSteps)
    : stepType.empty;

  return new TypedStep(stepType, defaultState);
}
